export class Documents {
    static readonly agb = '/static/documents/AKB.pdf';
    static readonly privacyPolicy = '/static/documents/Datenschutzhinweis_Maas Insurance_MeinAuto.pdf';
    static readonly mediationRegulation = '/static/documents/Erstinformation_Maas Insurance.pdf';
    static readonly cancellationPolicy = '/static/documents/Widerrufsrecht_Ihrer_Kfz-Versicherung.pdf';
}